"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledgeProject.form.title.edit': '编辑项目',
    'knowledgeProject.form.title.add': '添加项目',
    'knowledgeProject.form.back': '返回',
    'knowledgeProject.form.color.placeholder': '#007bff',
    'knowledgeProject.form.icon.placeholder': 'fas fa-folder',
};
